import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgWalletLine = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill={props.color}
      d='M16.5 14q1.5 0 1.5-1.5T16.5 11 15 12.5t1.5 1.5'
    />
    <path
      fill={props.color}
      fillRule='evenodd'
      d='M2 6a3 3 0 0 1 3-3h8.764a3 3 0 0 1 2.683 1.658L17.618 7H19a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3zm15.022 3H5c-.35 0-.687-.06-1-.17V18a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-8a1 1 0 0 0-1-1zm-2.364-3.447L15.382 7H5a1 1 0 0 1 0-2h8.764a1 1 0 0 1 .894.553'
      clipRule='evenodd'
    />
  </svg>
)
const ForwardRef = forwardRef(SvgWalletLine)
export default ForwardRef
